module.exports = __webpack_public_path__ + "img/mas_buscados_6.df1ce5b5.png";